import { ErrorBoundary } from '@sentry/react';
import React, { Suspense } from 'react';

import { TableSkeleton } from '@eluve/blocks';
import { Stack, Text } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

import { PatientAppointmentsList } from '../PatientAppointmentsList';

export const PatientAppointmentsTab: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<TableSkeleton rowCount={20} />}>
      <ErrorBoundary
        fallback={
          <Stack gap={2}>
            <Text>{t('patients.profile.appointmentsLoadFailed')}</Text>
            <TableSkeleton rowCount={5} />
          </Stack>
        }
      >
        <PatientAppointmentsList />
      </ErrorBoundary>
    </Suspense>
  );
};
